import { HxActiveSetEvent } from '@outlook/hxcore_web';
import { getHxInstance } from 'hx-session';

/**
 * Wait until a we see a change notification that satisifies a specific change evaluator.
 */
export function waitForHxChange<T>(
    evaluator: (event: HxActiveSetEvent) => T | undefined,
    timeout: number
): Promise<T> {
    const activeSet = getHxInstance().activeSet;
    return new Promise<T>((resolve, reject) => {
        let timerHandle;
        const handler = {
            onActiveSetChanged: (events: ReadonlyArray<HxActiveSetEvent>) => {
                for (let i = 0; i < events.length; i++) {
                    const result = evaluator(events[i]);
                    if (result) {
                        activeSet.unregisterHandler(handler);
                        clearTimeout(timerHandle);
                        resolve(result);
                    }
                }
            },
        };

        activeSet.registerHandler(handler);
        timerHandle = setTimeout(() => {
            activeSet.unregisterHandler(handler);
            reject(new Error('waitForHxChange timed out'));
        }, timeout);
    });
}
